import FinaceComissionView from 'components/organisms/finance-comission/FinaceComissionView'
import React from 'react'

const FinanceCommission = () => {
  return (
    <FinaceComissionView />
  )
}

export default FinanceCommission